/* eslint-disable import/prefer-default-export */
// Utils
import { get } from 'lodash';
import moment from 'moment';

// Constants
import Constants, { BodyComponentConsts } from 'client/util/Constants';

const { dateFormat } = Constants;

const getMfaEnrollmentValue = (user, type) => get(user, ['mfaEnrollment', type]);
const makeBold = value => (value ? `**${value}**` : value);

export const getTotpTooltipText = (user) => {
  const enrollmentPeriodExpiration = get(user, ['mfa', 'exclusionUntil'], '');
  const formattedDate = enrollmentPeriodExpiration
    && moment(new Date(enrollmentPeriodExpiration)).format(dateFormat);
  const dateAppendage = formattedDate ? `until ${formattedDate}` : 'with no end date';

  const username = get(user, 'username', '');
  const boldUsername = makeBold(username);

  const mappedStatusValues = [
    { statusValue: 'NOT_ENROLLED', text: `This user ${boldUsername} hasn't completed TOTP (Verification Code) enrollment.` },
    { statusValue: 'DISABLED', text: 'NA' },
    { statusValue: 'PENDING_ACTIVATION', text: `This user ${boldUsername} is in a TOTP (Verification Code) enrollment period with no end date.` },
    { statusValue: 'ENROLLMENT_EXPIRED', text: `This user ${makeBold(`${username}'s`)} TOTP (Verification Code) enrollment period expired on ${formattedDate}.` },
    { statusValue: 'IN_ENROLLMENT', text: `This user ${boldUsername} is in a TOTP (Verification Code) enrollment period ${dateAppendage}.` },
    { statusValue: 'PRE_ENROLLMENT', text: `${makeBold(`${username}'s`)} TOTP (Verification Code) enrollment period starts when their user state changes to active.` },
    { statusValue: 'ENROLLED', text: `This user ${boldUsername} has successfully completed TOTP (Verification Code) enrollment.` },
  ];

  const totpMfaStatus = getMfaEnrollmentValue(user, BodyComponentConsts.mfaTypes.totp);

  const status = mappedStatusValues.find(({ statusValue }) => statusValue === totpMfaStatus);

  return status.text;
};

export const getOverallTooltipText = (user) => {
  const username = makeBold(get(user, 'username', ''));

  const totpMfaStatus = getMfaEnrollmentValue(user, BodyComponentConsts.mfaTypes.totp);
  const totpValue = totpMfaStatus === 'ENROLLED' && 'TOTP (Verification Code)';

  const pushMfaStatus = getMfaEnrollmentValue(user, BodyComponentConsts.mfaTypes.push);
  const pushValue = pushMfaStatus === 'ENROLLED' && 'JumpCloud Protect';

  const webAuthnMfaStatus = getMfaEnrollmentValue(user, BodyComponentConsts.mfaTypes.webAuthn);
  const webAuthnValue = webAuthnMfaStatus === 'ENROLLED' && 'WebAuthn Security Keys';

  const values = [totpValue, pushValue, webAuthnValue].filter((x) => x).join(', ');

  const overallMfaStatus = getMfaEnrollmentValue(user, BodyComponentConsts.mfaTypes.overall);

  return overallMfaStatus === 'ENROLLED'
    ? `This user ${username} is enrolled in the following MFA methods: ${values}.`
    : `This user ${username} isn't enrolled in any MFA methods.`;
};

export const getPushTooltipText = (user) => {
  const username = get(user, 'username', '');
  const boldUsername = makeBold(username);

  const mappedStatusValues = [
    { statusValue: 'NOT_ENROLLED', text: `This user ${boldUsername} hasn't completed JumpCloud Protect enrollment.` },
    { statusValue: 'DISABLED', text: `This user ${makeBold(`${username}'s`)} JumpCloud Protect devices are currently disabled.` },
    { statusValue: 'PENDING_ACTIVATION', text: `This user ${boldUsername} JumpCloud Protect enrollment is pending activation.` },
    { statusValue: 'ENROLLED', text: `This user ${boldUsername} has successfully completed JumpCloud Protect enrollment.` },
  ];

  const pushMfaStatus = getMfaEnrollmentValue(user, BodyComponentConsts.mfaTypes.push);

  const status = mappedStatusValues.find(({ statusValue }) => statusValue === pushMfaStatus);

  return status.text;
};

export const getWebAuthnTooltipText = (user) => {
  const username = makeBold(get(user, 'username', ''));

  const webAuthnMfaStatus = getMfaEnrollmentValue(user, BodyComponentConsts.mfaTypes.webAuthn);

  return webAuthnMfaStatus === 'ENROLLED'
    ? `This user ${username} has successfully completed WebAuthn enrollment.`
    : `This user ${username} hasn't completed WebAuthn enrollment.`;
};
